import { instance, ajaxQueueManage } from "../api/_axios";
//生成caceltoken---------
import axios from "axios"
let CancelToken = axios.CancelToken
//----------------------
let myAjaxQueueManage = new ajaxQueueManage()
import { getCookie } from "./cookie";

function setting() {
  if (!this.LOGGIN_STATUS) {
    this.notLoginMethod();
  }
  document.title = "智影";
  //全局axios请求拦截,添加header字段，内容为token
  instance.interceptors.request.use(
    config => {
      try {
        if (myAjaxQueueManage.include_host.includes(config.url)) {
          myAjaxQueueManage.removeQueue(config); // 中断之前的同名请求
          // 添加cancelToken
          // console.log()
          let token = myAjaxQueueManage.getToken(config)
          config.cancelToken = new CancelToken(c => {
            myAjaxQueueManage.addQueue({ token: token, cancel: c });
          });
        }
      } catch (e) { }
      //获取根域cookie,key
      const token = getCookie("qmovie_token");
      if (token) {
        config.headers.Authorization = token;
      }
      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );
  // 全局axiox状态捕获（响应前置钩子）
  instance.interceptors.response.use(
    response => {
      try {
        if (myAjaxQueueManage.include_host.includes(config.url)) {
          // 在请求完成后，自动移出队列
          removeQueue(response.config);
        }
      } catch (e) { }
      // 对响应数据做点什么
      let code = response.data.code;
      if (code === 401) {
        // code-401: 未登录状态
        // this.$store.dispatch("user/logout");
      } else if (code >= 400 && code < 500) {
        // 400系错误
        // this.$store.commit("error/setError", { error: response.data.msg });
      } else if (code >= 500 && code < 600) {
        // 500系错误
      } else if (code >= 600) {
        // 600系错误
        let errInfo = undefined;
        // this.$store.commit("error/setError", { error: response.data.msg });
        if (code === 601) {
          if (!this.$store.getters['user/isLogined']) {
          } else {
            //logout
            this.$store.commit("user/setUserInfo", null);
            // this.$store.commit("user/logout").then(() => {
            //因token过期 内部退出时，提示
            errInfo = "登陆已过期，请重新登录";
            this.$confirm(errInfo, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(action => {
              // this.$router.push({ path: '/login' })
            });
            // });
          }
        } else if (code === 602) {
          if (!this.$store.getters['user/isLogined']) {
            return
          }
          //logout
          this.$store.dispatch("user/logout");
          // errInfo = "此账号无使用权限";
          //因权限过期 在内部退出时，均提示登录过期，暂不提示权限过期
          errInfo = "登陆已过期，请重新登录";
          this.$confirm(errInfo, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(action => {
            // this.$store.dispatch("user/logout");
            this.$router.push({ path: '/login' })
          });
        } else if (code === 603) {
          //登录时如果没有权限返回603
        }
      }
      return response;
    },
    error => {
      if (error.message === "cancel") {
        // 不错处理
        return Promise.reject(error);
      }
      if (!error.response) {
        // 断网了
        // Toast({
        //   message: "网络异常，请检查网络连接",
        //   duration: 3000
        // });
        this.$notify.error({
          title: '错误',
          message: '网络异常，请检查网络连接'
        })
      }
      // this.$store.commit("error/setError", { error: error.message });
      return Promise.reject(error);
    }
  );
}

export default setting 